var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav",staticStyle:{"padding-bottom":"46px"}},[_c('van-nav-bar',{attrs:{"title":_vm.title,"fixed":"","left-arrow":""},on:{"click-left":function($event){return _vm.goUrl(_vm.url)}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }